import {endpoints, types} from 'main/tools';
import {observer} from 'mobx-react';
import FilterComponent from 'main/components/tables/interactive/components/fancy_filter/filter_selector/FilterComponent';
import useFetchModels from 'shared/hooks/useFetchModels';

const Location = observer(({filter, filterKey, filterUpdated, filterDeleted, Wrapper}) => {
  const [models, isLoading] = useFetchModels(endpoints.LOCATIONS.ALL, types.LOCATION);
  const options = models.map(location => ({ label: location.name, value: location.id }));

  return <FilterComponent
    filter={filter}
    filterKey={filterKey}
    options={options}
    filterUpdated={filterUpdated}
    filterDeleted={filterDeleted}
    Wrapper={Wrapper}
    isLoading={isLoading}
    searchable
  />;
});

export default Location;
